import { PageWeb } from '@nucleus/types/web';
import { useUser } from '@nucleus/web-theme';
import { UseSuspenseQueryResult, useSuspenseQuery } from '@tanstack/react-query';
import { querySermonPage } from '../query/querySermonPage';

type QueryResult = Extract<Awaited<ReturnType<typeof querySermonPage>>, { page: PageWeb }>;

export const useSermonPage = (
  engineId: string,
  basePath: string,
  slug: string
): UseSuspenseQueryResult<QueryResult> => {
  const { currentUser, jwtToken } = useUser();

  return useSuspenseQuery({
    queryKey: ['sermonHub', 'page', slug, currentUser?.id],
    queryFn: () => querySermonPage(engineId, basePath, slug, jwtToken),
    refetchOnWindowFocus: false,
    retry: false,
  });
};
